<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('title.asnDetailEdit')" type="confirm" width="60%" @cancel="cancel" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="detail" :rules="rules" :wrapper-col="wrapperCol">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.itemNo')" prop="itemNo">
            <vxe-input v-model="detail.item.no" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.itemName')" prop="itemName">
            <vxe-input v-model="detail.item.name" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.arrivalQuantity')" prop="quantity">
            <vxe-number-input v-model="detail.quantity" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.specification')" prop="specification">
            <vxe-input v-model="detail.pack.specification" :editable="false" style="width: 100%" @click="onPackSelect"/>
            <pack-modal ref="packModal" @change="onPackChange"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.uom')" prop="uom">
            <vxe-input v-model="detail.pack.uom" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.factor')" prop="factor">
            <vxe-input v-model="detail.pack.factor" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.lot')" prop="lotNo">
            <vxe-input v-model="detail.lotNo" :editable="false" style="width: 100%" @click="onLotSelect"/>
            <lot-modal ref="lotModal" @change="onLotChange"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.productionDate')" prop="productionDate">
            <a-date-picker v-model="detail.productionDate" format="YYYY-MM-DD" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.validUntil')" prop="validUntil">
            <a-date-picker v-model="detail.validUntil" format="YYYY-MM-DD" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.manufacturer')" prop="manufacturer">
            <vxe-select v-model="detail.manufacturer" :options="manufacturers" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.producingArea')" prop="producingArea">
            <vxe-select v-model="detail.producingArea" :options="producingAreas" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.approvalNo')" prop="approvalNo">
            <vxe-input v-model="detail.approvalNo" :editable="false" style="width: 100%" @click="onApprovalNoSelect"/>
            <approval-modal ref="approvalModal" @change="onApprovalNoChange"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.licenseNo')" prop="license">
            <vxe-input v-model="detail.license.licenseNo" :editable="false" style="width: 100%" @click="onLicenseSelect"/>
            <license-modal ref="licenseModal" @change="onLicenseChange"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.permissionNo')" prop="permission">
            <vxe-input v-model="detail.permission.permissionNo" :editable="false" style="width: 100%" @click="onPermissionSelect"/>
            <permission-modal ref="permissionModal" @change="onPermissionChange"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.practiceNo')" prop="practice">
            <vxe-input v-model="detail.practice.practiceNo" :editable="false" style="width: 100%" @click="onPracticeSelect"/>
            <practice-modal ref="practiceModal" @change="onPracticeChange"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.qualityStandard')" prop="quality">
            <vxe-input v-model="detail.quality.qualityStandard" :editable="false" style="width: 100%" @click="onQualitySelect"/>
            <quality-modal ref="qualityModal" @change="onQualityChange"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.departureTemp')" prop="departureTemp">
            <vxe-number-input v-model="detail.temperature.departureTemp" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.arrivalTemp')" prop="arrivalTemp">
            <vxe-number-input v-model="detail.temperature.arrivalTemp" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.maximumTemp')" prop="maximumTemp">
            <vxe-number-input v-model="detail.temperature.maximumTemp" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.minimumTemp')" prop="minimumTemp">
            <vxe-number-input v-model="detail.temperature.minimumTemp" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import { post } from '@/api/Api'
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import ACol from 'ant-design-vue/es/grid/Col'
import ARow from 'ant-design-vue/es/grid/Row'
import { AsnDetail, AsnOrder } from '@/api/dto/order/AsnOrder'
import PackModal from '@/views/modal/PackModal.vue'
import { Pack } from '@/api/dto/common/Pack'
import LotModal from '@/views/modal/LotModal.vue'
import { License } from '@/api/dto/valueobject/License'
import { Practice } from '@/api/dto/valueobject/Practice'
import { Permission } from '@/api/dto/valueobject/Permission'
import { Quality } from '@/api/dto/valueobject/Quality'
import ApprovalModal from '@/views/inbound/asn/modal/ApprovalModal.vue'
import LicenseModal from '@/views/inbound/asn/modal/LicenseModal.vue'
import PermissionModal from '@/views/inbound/asn/modal/PermissionModal.vue'
import PracticeModal from '@/views/inbound/asn/modal/PracticeModal.vue'
import QualityModal from '@/views/inbound/asn/modal/QualityModal.vue'
import Api from '@/api'

export default {
  name: 'AsnDetailEditModal',
  computed: {
    Quality() {
      return Quality
    },
    Permission() {
      return Permission
    },
    Practice() {
      return Practice
    },
    License() {
      return License
    },
    Pack() {
      return Pack
    }
  },
  components: {
    QualityModal,
    PracticeModal,
    PermissionModal,
    LicenseModal,
    ApprovalModal,
    LotModal,
    PackModal,
    ARow,
    ACol
  },
  data() {
    return {
      visible: false,
      loading: false,
      warehouse: Vue.ls.get(WAREHOUSE),
      isAdd: false,
      isEdit: false,
      order: new AsnOrder(),
      detail: new AsnDetail(),
      manufacturers: [],
      producingAreas: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {}
    }
  },
  methods: {
    open(order, detail) {
      this.order = order
      this.detail = detail
      this.manufacturers = detail.item.manufacturer.split(',').map(item => {
        return { value: item, label: item }
      })
      this.producingAreas = detail.item.producingArea.split(',').map(item => {
        return { value: item, label: item }
      })
      this.visible = true
      this.isAdd = false
      this.isEdit = true
    },
    onPackSelect() {
      this.$refs.packModal.open({ 'item.id': this.detail.item.id })
    },
    onPackChange(values) {
      this.detail.pack = new Pack(values[0])
    },
    onLotSelect() {
      this.$refs.lotModal.open({ 'item.id': this.detail.item.id })
    },
    onLotChange(values) {
      this.detail.lotNo = values.length === 0 ? null : values[0].no
      this.detail.validUntil = values.length === 0 ? null : values[0].validUntil
      this.detail.productionDate = values.length === 0 ? null : values[0].productionDate
      this.detail.manufacturer = values.length === 0 ? null : values[0].manufacturer
      this.detail.producingArea = values.length === 0 ? null : values[0].producingArea
      this.detail.approvalNo = values.length === 0 ? null : values[0].approvalNo
      this.detail.license = values.length === 0 ? new License() : Object.assign(new License(), values[0].license)
      this.detail.practice = values.length === 0 ? new Practice() : Object.assign(new Practice(), values[0].practice)
      this.detail.permission = values.length === 0 ? new Permission() : Object.assign(new Permission(), values[0].permission)
      this.detail.quality = values.length === 0 ? new Quality() : Object.assign(new Quality(), values[0].quality)
    },
    onApprovalNoSelect() {
      this.$refs.approvalModal.open({ 'itemId': this.detail.item.id })
    },
    onApprovalNoChange(values) {
      this.$nextTick(() => {
        this.detail.approvalNo = values.length === 0 ? null : values[0].approvalNo
      })
    },
    onLicenseSelect() {
      this.$refs.licenseModal.open({ 'itemId': this.detail.item.id })
    },
    onLicenseChange(values) {
      this.detail.license = new License(values[0])
    },
    onPermissionSelect() {
      this.$refs.permissionModal.open({ 'itemId': this.detail.item.id })
    },
    onPermissionChange(values) {
      this.detail.permission = new Permission(values[0])
    },
    onPracticeSelect() {
      this.$refs.practiceModal.open({ 'itemId': this.detail.item.id })
    },
    onPracticeChange(values) {
      this.detail.practice = new Practice(values[0])
    },
    onQualitySelect() {
      this.$refs.qualityModal.open({ 'itemId': this.detail.item.id })
    },
    onQualityChange(values) {
      this.detail.quality = new Quality(values[0])
    },
    save() {
      this.loading = true
      const order = this.order.toJSONObject()
      order.details = [this.detail.toJSONObject()]
      post(Api.receivingAsnSave, { type: 'normalAsn' }, order).then(res => {
        if (res.success) {
          this.$message.success('保存成功')
          this.$emit('success', res.result)
          this.cancel()
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate(success => {
        if (success) {
          this.save()
        }
      })
    },
    cancel() {
      this.visible = false
    }
  }
}
</script>